import React from "react";
import { IClient } from "../../../models/client";
import dayjs from "dayjs";
import numWord from "../../../utils/numWord";
import classes from "./ClientInfo.module.scss";

interface IClientInfoProps {
  data: IClient;
  isLoading?: boolean;
}

export default function ClientInfo({ data, isLoading }: IClientInfoProps) {
  const curDate = new Date();
  const birthDate = new Date(data.birthday);
  const diffDate = curDate.getFullYear() - birthDate.getFullYear();
  const formattedBirthday = dayjs(data.birthday, "YYYY-MM-DD").format(
    "DD.MM.YYYY"
  );
  const yearsCount = `${diffDate} ${numWord(diffDate, ["год", "года", "лет"])}`;
  const birthDateTemplate = !isLoading && (
    <>
      {formattedBirthday} <span>({yearsCount})</span>
    </>
  );

  return (
    <div className={[classes.wrap, isLoading && classes.loading].join(" ")}>
      <div className={classes.title}>{data.fio}</div>
      <div className={classes.list}>
        <div className={classes.item}>
          <div className={classes.item_label}>Телефон:</div>
          <div
            className={[classes.item_value, classes.item_value_phone].join(" ")}
          >
            {data.phone}
          </div>
        </div>
        {/*      <div className={classes.item}>
          <div className={classes.item_label}>Дата рождения:</div>
          <div
            className={[classes.item_value, classes.item_value_birthdate].join(
              " "
            )}
          >
            {birthDateTemplate}
          </div>
        </div>*/}
        {data.height && (
          <div className={classes.item}>
            <div className={classes.item_label}>Рост:</div>
            <div
              className={[classes.item_value, classes.item_value_height].join(
                " "
              )}
            >
              {!isLoading && `${data.height} см`}
            </div>
          </div>
        )}
        <div className={classes.item}>
          <div className={classes.item_label}>Вес:</div>
          <div className={classes.item_value}>
            {!isLoading && `${data.weight} кг`}
          </div>
        </div>
      </div>
    </div>
  );
}
